import React, { Component } from "react";
import {
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    Avatar,
    Divider,
    IconButton,
    Link as MuiLink
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { comment, uncomment } from "./apiPost";
import { isAuthenticated } from "../auth";
import { Link } from "react-router-dom";
import DefaultProfile from "../images/avatar.png";

class Comment extends Component {
    state = {
        text: "",
        error: ""
    };

    handleChange = event => {
        this.setState({ error: "" });
        this.setState({ text: event.target.value });
    };

    isValid = () => {
        const { text } = this.state;
        if (!text.length > 0 || text.length > 500) {
            this.setState({
                error:
                    "Comment should not be empty and less than 500 characters long"
            });
            return false;
        }
        return true;
    };

    addComment = e => {
        e.preventDefault();

        if (!isAuthenticated()) {
            this.setState({ error: "Please signin to leave a comment" });
            return false;
        }

        if (this.isValid()) {
            const userId = isAuthenticated().userId;
            const token = isAuthenticated().token;
            const postId = this.props.postId;

            comment(userId, token, postId, { text: this.state.text }).then(
                data => {
                    if (data.error) {
                        console.log(data.error);
                    } else {
                        this.setState({ text: "" });
                        // dispatch fresh list of coments to parent (SinglePost)
                        this.props.updateComments(data.comments);
                    }
                }
            );
        }
    };

    deleteComment = comment => {
        const userId = isAuthenticated().userId;
        const token = isAuthenticated().token;
        const postId = this.props.postId;

        uncomment(userId, token, postId, comment).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.props.updateComments(data.comments);
            }
        });
    };

    deleteConfirmed = comment => {
        let answer = window.confirm(
            "Are you sure you want to delete your comment?"
        );
        if (answer) {
            this.deleteComment(comment);
        }
    };

    render() {
        const { comments } = this.props;
        const { error } = this.state;

        return (
            <Box sx={{ mt: 5 }}>
                <Typography variant="h5" sx={{ mb: 3 }}>
                    Leave a comment
                </Typography>

                <Box component="form" onSubmit={this.addComment} sx={{ mb: 3 }}>
                    <TextField
                        fullWidth
                        onChange={this.handleChange}
                        value={this.state.text}
                        placeholder="Leave a comment..."
                        variant="outlined"
                        margin="normal"
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="success"
                        sx={{ mt: 2 }}
                    >
                        Post
                    </Button>
                </Box>

                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}

                <Typography variant="h5" color="primary" gutterBottom>
                    {comments.length} Comments
                </Typography>
                <Divider sx={{ mb: 2 }} />

                {comments.map((comment, i) => (
                    <Box key={i} sx={{ mb: 3 }}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <MuiLink component={Link} to={`/user/${comment.postedBy._id}`}>
                                <Avatar
                                    src={`${process.env.REACT_APP_API_URL}/user/photo/${comment.postedBy._id}`}
                                    alt={comment.postedBy.name}
                                    sx={{ width: 40, height: 40 }}
                                    imgProps={{
                                        onError: (e) => {
                                            e.target.src = DefaultProfile;
                                        }
                                    }}
                                />
                            </MuiLink>
                            <Box sx={{ flexGrow: 1 }}>
                                <Typography variant="body1" sx={{ mb: 1 }}>
                                    {comment.text}
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" sx={{ fontStyle: 'italic', backgroundColor: '#fff3cd', px: 1, borderRadius: 1 }}>
                                        Posted by{" "}
                                        <MuiLink component={Link} to={`/user/${comment.postedBy._id}`} underline="hover">
                                            {comment.postedBy.name}
                                        </MuiLink>
                                        {" "}on {new Date(comment.created).toDateString()}
                                    </Typography>
                                    {isAuthenticated().user &&
                                        isAuthenticated().userId === comment.postedBy._id && (
                                            <IconButton
                                                size="small"
                                                color="error"
                                                onClick={() => this.deleteConfirmed(comment)}
                                                title="Remove comment"
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        )}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                ))}
            </Box>
        );
    }
}

export default Comment;